import ContasPagasStrategy from "./ContasPagasStrategy";

export default class ContasRecebidasStrategy extends ContasPagasStrategy {
  processar(dadosBrutos) {
    // A estrutura é idêntica à de ContasPagas, mas com título e labels diferentes
    const resultado = super.processar(dadosBrutos);
    resultado.titulo = "CONTAS RECEBIDAS";

    // Ajusta os nomes dos grupos de "FORNECEDOR" para "CLIENTE" e "SUPPLIER" para "CLIENT"
    resultado.grupos = resultado.grupos.map((grupo) => ({
      ...grupo,
      nome: grupo.nome.replace("FORNECEDOR:", "CLIENTE:").replace("SUPPLIER:", "CLIENT:"),
    }));

    return resultado;
  }

  /**
   * Herda getFormComponent() de ContasPagasStrategy (retorna FormLiquidadas).
   * O formulário de liquidadas é o mesmo para Contas Pagas e Contas Recebidas.
   */

  /**
   * Sobrescreve o nome do grupo para usar "CLIENTE" em vez de "FORNECEDOR".
   * @param {Object} item - Item do relatório bruto
   * @returns {string} Nome formatado do grupo
   */
  _getNomeGrupo(item) {
    const nomeBase = super._getNomeGrupo(item);
    return nomeBase.replace("FORNECEDOR:", "CLIENTE:");
  }
}